import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {
  HistoryTicket,
  HistoryTicketType,
} from '@fullyops/data/history/history';
import { TicketType } from '@fullyops/legacy/data';
import { ComponentInOutAnimation } from '@fullyops/shared/util/component-base-animation';
import {
  PermissionType,
  TicketTypeIcon,
} from '@fullyops/legacy/ui/ui-shared/utils/crm-types';
import { DisableLinkIfNotAllowedDirective } from '@fullyops/shared/directives/disable-link-if-not-allowed.directive';
import { MaterialModule } from '@fullyops/shared/material.module';
import { MomentTimezoneToAngularTimezonePipe } from '@fullyops/shared/pipes/moment-timezone-to-angular-timezone.pipe';
import { I18NextModule } from 'angular-i18next';

interface TicketItem extends HistoryTicket {
  readonly completed: boolean;
}

export interface OpenTicketEvent {
  ticketId: string;
  ticketType: HistoryTicketType;
}

@Component({
  selector: 'crm-history-ticket',
  templateUrl: './history-ticket.component.html',
  styleUrls: ['./history-ticket.component.scss'],
  animations: [ComponentInOutAnimation.AnimTrigger],
  standalone: true,
  imports: [
    MaterialModule,
    I18NextModule,
    DisableLinkIfNotAllowedDirective,
    MomentTimezoneToAngularTimezonePipe,
  ],
})
export class HistoryTicketComponent implements OnInit {
  @Input() ticket: TicketItem;
  @Input() type: HistoryTicketType;
  @Output() openTicketEvent = new EventEmitter<OpenTicketEvent>();

  TicketType = TicketType;
  ticketPermissions = [];
  Icon = TicketTypeIcon;

  ngOnInit() {
    switch (this.type) {
      case TicketType.REQUEST:
        this.ticketPermissions.push(
          PermissionType.CAN_ACCESS_REQUEST_TICKETS,
          PermissionType.CAN_ACCESS_OWN_REQUEST_TICKETS,
        );
        break;
      case TicketType.SUPPORT:
        this.ticketPermissions.push(PermissionType.CAN_ACCESS_SUPPORT_TICKETS);
        break;
      default:
        break;
    }
  }

  openTicket() {
    this.openTicketEvent.emit({
      ticketId: this.ticket.id,
      ticketType: this.type,
    });
  }
}
